document.addEventListener("DOMContentLoaded", function() {
    // Handle feature accordion image switching
    const featureAccordions = document.querySelectorAll('.feature-accordion');

    if (featureAccordions.length === 0) return;

    featureAccordions.forEach(featureAccordion => {
        const accordionHandles = featureAccordion.querySelectorAll('.accordion__handle[data-image-id]');
        const accordionImages = featureAccordion.querySelectorAll('.feature-accordion__image');

        if (accordionHandles.length === 0 || accordionImages.length === 0) return;

        // Initialize: show first image and mark first accordion as active image
        const firstImage = featureAccordion.querySelector('.feature-accordion__image[data-image-id="1"]');
        if (firstImage) {
            firstImage.classList.add('is-active');
        }

        accordionHandles.forEach(handle => {
            handle.addEventListener('click', function() {
                const imageId = this.getAttribute('data-image-id');

                // Hide all images in this feature accordion block
                accordionImages.forEach(img => {
                    img.classList.remove('is-active');
                });

                // Show the corresponding image
                const targetImage = featureAccordion.querySelector(`.feature-accordion__image[data-image-id="${imageId}"]`);
                if (targetImage) {
                    targetImage.classList.add('is-active');
                }
            });
        });
    });
});
